import React from "react";
import { IonCheckbox } from "@ionic/react";

class FormCheckbox extends React.Component {
  render() {
    const { value, onChange } = this.props.input;

    return (
      <IonCheckbox
        className="checkbox-circle"
        checked={!!value}
        onIonChange={(e) => {
          onChange(e.target.checked);
        }}
      />
    );
  }
}

export default FormCheckbox;
